import UserRoleEnum from '@/enums/user/role';

const CompanyRoleEnum = Object.freeze({
    SUPERUSER: UserRoleEnum.SUPERUSER,
    CONTENT_APPROVER: UserRoleEnum.CONTENT_APPROVER
});

export default CompanyRoleEnum;
